import React, { ReactElement } from "react";
import {
    AsyncObjectType, FormField, FormFieldType, FormFieldVisibility,
} from "../../../__generated__/api";
import { ReplacementGroup } from "../../replacement-group";
import Select from "../../select/Select";

export interface SelectedGroup {
    field: FormField;
    group: ReplacementGroup;
}

const USER_REPLACEMENTS = [
    { field: "name", name: "Name" },
    { field: "firstName", name: "First Name" },
    { field: "lastName", name: "Last Name" },
    { field: "email", name: "Email" },
];
export default function FieldSelector({
    input, value, onChange, shouldExpandUsers,
}: {
    input: ReplacementGroup[] | undefined
    value: SelectedGroup | undefined;
    onChange: (value: SelectedGroup | undefined) => void;
    shouldExpandUsers?: boolean;
}): ReactElement {
    return (
        <Select
            onChange={data => onChange(data.data)}
            value={!value ? undefined : {
                label: value.field.name,
                value: `${value.group.id}/${value.field.id}`,
                data: value,
            }}
            options={input?.mapFilter(row => {
                const children = row
                    .input?.filter(val => val.asyncObjectType !== AsyncObjectType.FieldInContext
                        && val.asyncObjectType !== AsyncObjectType.FieldsInContext
                        && (shouldExpandUsers || !(val.id as string).startsWith("urn:fq:workflow-user-field:"))
                        && val.id !== "urn:fq:form-field:fields");

                return !children?.isNotEmpty ? undefined : {
                    label: row.label,
                    value: row.id,
                    options: children?.flatMap(field => ({
                        label: field.name,
                        value: `${row.id}/${field.id}`,
                        data: {
                            field,
                            group: row,
                        } as SelectedGroup,
                    })),
                };
            }) ?? []}
        />
    );
}

FieldSelector.defaultProps = {
    shouldExpandUsers: false,
};
